<template>
  <!-- Formulario -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!-- Sigla Documento -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.DocumentoID"
          label="Sigla Documento:"
          clearable
          dense
          maxlength="10"
          counter="10"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Descripción -->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.Descripcion"
          label="Descripción:"
          clearable
          dense
          maxlength="100"
          counter="100"
          hint="Digite Información"
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-col>

      <!-- Tipo Contenido -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.TipoContenido"
          :items="ArrayTipoContenido"
          :item-title="
            (ArrayTipoContenido) =>
              ArrayTipoContenido.Valor + '-' + ArrayTipoContenido.Descripcion
          "
          item-value="Valor"
          label="Tipo Contenido:"
          dense
          clearable
          :rules="[rules.required]"
          @update:modelValue="ChangeTipoContenido()"
        >
        </v-autocomplete>
      </v-col>

      <!-- Indicativo Carpeta -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.IndicativoCarpeta"
          :items="ArrayIndicativoCarpeta"
          :item-title="
            (ArrayIndicativoCarpeta) =>
              ArrayIndicativoCarpeta.Valor + '-' + ArrayIndicativoCarpeta.Descripcion
          "
          item-value="Valor"
          label="Indicativo Carpeta:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Servidor -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.RutaServidorID"
          :items="ArrayServidores"
          :item-title="
            (ArrayServidores) => ArrayServidores.ServidorId + '-' + ArrayServidores.Nombre
          "
          item-value="ServidorId"
          label="Servidor:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Ruta -->
      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="editedItem.RutaID"
          :items="ArrayRutas"
          :item-title="(ArrayRutas) => ArrayRutas.RutaID + '-' + ArrayRutas.RutaFisica"
          item-value="RutaID"
          label="Ruta :"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Servidor Combinación -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.RutaServidorIDCombinacion"
          :items="ArrayServidores"
          :item-title="
            (ArrayServidores) => ArrayServidores.ServidorId + '-' + ArrayServidores.Nombre
          "
          item-value="ServidorId"
          label="Servidor Combinación:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Ruta Combinación -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.RutaIDCombinacion"
          :items="ArrayRutas"
          :item-title="(ArrayRutas) => ArrayRutas.RutaID + '-' + ArrayRutas.RutaFisica"
          item-value="RutaID"
          label="Ruta Combinación:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Servidor Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.RutaPlantillaServidorID"
          :items="ArrayServidores"
          :item-title="
            (ArrayServidores) => ArrayServidores.ServidorId + '-' + ArrayServidores.Nombre
          "
          item-value="ServidorId"
          label="Servidor Plantilla:"
          dense
          clearable
          :rules="
            editedItem.TipoContenido == TipoContenido.MergeDocument
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Ruta Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="6"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.RutaPlantillaID"
          :items="ArrayRutas"
          :item-title="(ArrayRutas) => ArrayRutas.RutaID + '-' + ArrayRutas.RutaFisica"
          item-value="RutaID"
          label="Ruta Plantilla:"
          dense
          clearable
          :rules="
            editedItem.TipoContenido == TipoContenido.MergeDocument
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Nombre Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="4"
        md="4"
      >
        <v-text-field
          v-model="editedItem.NombrePlantilla"
          label="Nombre Plantilla:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
          :rules="
            editedItem.TipoContenido == TipoContenido.MergeDocument
              ? [rules.required]
              : []
          "
        >
        </v-text-field>
      </v-col>

      <!-- Formato Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="4"
        md="4"
      >
        <v-autocomplete
          v-model="editedItem.FormatoPlantilla"
          :items="ArrayFormatos"
          :item-title="(ArrayFormatos) => ArrayFormatos.ExtEntrada"
          item-value="ExtEntrada"
          label="Formato Plantilla:"
          dense
          clearable
          :rules="
            editedItem.TipoContenido == TipoContenido.MergeDocument
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Fila Columna Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.MergeDocument"
        cols="12"
        sm="4"
        md="4"
      >
        <v-text-field
          v-model="editedItem.FilaColumnaPlantilla"
          label="Fila Columna Plantilla:"
          clearable
          dense
          type="tel"
          maxlength="3"
          counter="3"
        >
        </v-text-field>
      </v-col>

      <!-- Plantilla -->
      <v-col
        v-if="editedItem.TipoContenido == TipoContenido.TemplateWorkMergeDocument"
        cols="12"
        sm="12"
        md="12"
      >
        <v-autocomplete
          v-model="editedItem.PlantillaID"
          :items="ArrayPlantillas"
          :item-title="
            (ArrayPlantillas) =>
              ArrayPlantillas.id + '-' + ArrayPlantillas.DescPlantilla_ID
          "
          item-value="id"
          label="Plantilla:"
          dense
          clearable
          :rules="
            editedItem.TipoContenido == TipoContenido.TemplateWorkMergeDocument
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Indicativo Foto -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.IndicativoFoto"
          color="red-darken-3"
          label="Indicativo Foto"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Requiere Verificacion -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.RequiereVerificacion"
          color="red-darken-3"
          label="Requiere Verificación"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Chequea Vigencias -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.ChequeaVigencias"
          color="red-darken-3"
          label="Chequea Vigencias"
          hide-details
          inset
          @update:modelValue="ChangeVigencia()"
        ></v-switch>
      </v-col>

      <!-- Dias Vigencia  -->
      <v-col v-if="editedItem.ChequeaVigencias" cols="12" sm="2" md="2">
        <v-text-field
          v-model="editedItem.DiasVigencia"
          label="Días de Vigencia:"
          clearable
          dense
          type="tel"
          v-on:keypress="isNumber()"
          maxlength="16"
          counter="16"
          :rules="editedItem.DiasVigencia ? [rules.required] : []"
        >
        </v-text-field>
      </v-col>

      <!-- Visible Personas -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisiblePersonas"
          color="red-darken-3"
          label="Visible Personas"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Visible Contratos -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleContratos"
          color="red-darken-3"
          label="Visible Contratos"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Visible Activos -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleActivos"
          color="red-darken-3"
          label="Visible Activos"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!--Visible Inventarios -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleInventarios"
          color="red-darken-3"
          label="Visible Inventarios"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!--Visible Solicitud -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleSolicitud"
          color="red-darken-3"
          label="Visible Solicitud"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!--Visible Caso -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleCaso"
          color="red-darken-3"
          label="Visible Caso"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!--Visible Gestion -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleGestion"
          color="red-darken-3"
          label="Visible Gestión"
          hide-details
          inset
        ></v-switch>
      </v-col>

      <!-- Visible Servicios -->
      <v-col cols="12" sm="3" md="3">
        <v-switch
          v-model="editedItem.VisibleServicios"
          color="red-darken-3"
          label="Visible Servicios"
          hide-details
          inset
          @update:modelValue="ChangeServicios()"
        ></v-switch>
      </v-col>

      <!-- Servicio 1 -->
      <v-col v-if="editedItem.VisibleServicios" cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ServicioID1"
          :items="ArrayServicios"
          :item-title="
            (ArrayServicios) =>
              ArrayServicios.ServicioID + '-' + ArrayServicios.DescripcionServicio
          "
          item-value="ServicioID"
          label="Servicio 1:"
          dense
          :rules="editedItem.VisibleServicios ? [rules.required] : []"
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Servicio 2 -->
      <v-col v-if="editedItem.VisibleServicios" cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ServicioID2"
          :items="ArrayServicios"
          :item-title="
            (ArrayServicios) =>
              ArrayServicios.ServicioID + '-' + ArrayServicios.DescripcionServicio
          "
          item-value="ServicioID"
          label="Servicio 2:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Servicio 3 -->
      <v-col v-if="editedItem.VisibleServicios" cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ServicioID3"
          :items="ArrayServicios"
          :item-title="
            (ArrayServicios) =>
              ArrayServicios.ServicioID + '-' + ArrayServicios.DescripcionServicio
          "
          item-value="ServicioID"
          label="Servicio 3:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Servicio 4 -->
      <v-col v-if="editedItem.VisibleServicios" cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ServicioID4"
          :items="ArrayServicios"
          :item-title="
            (ArrayServicios) =>
              ArrayServicios.ServicioID + '-' + ArrayServicios.DescripcionServicio
          "
          item-value="ServicioID"
          label="Servicio 4:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Servicio 5 -->
      <v-col v-if="editedItem.VisibleServicios" cols="12" sm="4" md="4">
        <v-autocomplete
          v-model="editedItem.ServicioID5"
          :items="ArrayServicios"
          :item-title="
            (ArrayServicios) =>
              ArrayServicios.ServicioID + '-' + ArrayServicios.DescripcionServicio
          "
          item-value="ServicioID"
          label="Servicio 5:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>

      <!-- Nombre Icono -->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.NombreIcono"
          label="Nombre Icono:"
          clearable
          dense
          maxlength="50"
          counter="50"
          hint="Digite Información"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn size="x-large" v-if="!buttonSave" color="green" text @click="ValidateCampos">
        Guardar
      </v-btn>
    </div>
  </v-form>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  putUpdate,
  postInsert,
} from "@/views/TCI/Documentos/Documentos/DocumentosService";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import { TipoContenido } from "@/views/TCI/Documentos/Constantes/ConstantesDocumentos";

export default {
  name: "documentos-registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    userId: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      TipoContenido,
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        DocumentoID: null,
        Descripcion: null,
        TipoContenido: null,
        RutaServidorID: null,
        RutaID: null,
        RutaServidorIDCombinacion: null,
        RutaIDCombinacion: null,
        IndicativoFoto: false,
        RutaPlantillaServidorID: null,
        RutaPlantillaID: null,
        NombrePlantilla: null,
        FormatoPlantilla: null,
        FilaColumnaPlantilla: null,
        IndicativoCarpeta: null,
        ChequeaVigencias: false,
        DiasVigencia: null,
        RequiereVerificacion: false,
        VisiblePersonas: false,
        VisibleContratos: false,
        VisibleActivos: false,
        VisibleServicios: false,
        VisibleInventarios: false,
        VisibleSolicitud: false,
        VisibleCaso: false,
        VisibleGestion: false,
        ServicioID1: null,
        ServicioID2: null,
        ServicioID3: null,
        ServicioID4: null,
        ServicioID5: null,
        NombreIcono: null,
        PlantillaID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        DocumentoID: null,
        Descripcion: null,
        TipoContenido: null,
        RutaServidorID: null,
        RutaID: null,
        RutaServidorIDCombinacion: null,
        RutaIDCombinacion: null,
        IndicativoFoto: false,
        RutaPlantillaServidorID: null,
        RutaPlantillaID: null,
        NombrePlantilla: null,
        FormatoPlantilla: null,
        FilaColumnaPlantilla: null,
        IndicativoCarpeta: null,
        ChequeaVigencias: false,
        DiasVigencia: null,
        RequiereVerificacion: false,
        VisiblePersonas: false,
        VisibleContratos: false,
        VisibleActivos: false,
        VisibleServicios: false,
        VisibleInventarios: false,
        VisibleSolicitud: false,
        VisibleCaso: false,
        VisibleGestion: false,
        ServicioID1: null,
        ServicioID2: null,
        ServicioID3: null,
        ServicioID4: null,
        ServicioID5: null,
        NombreIcono: null,
        PlantillaID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayIndicativoCarpeta: [],
      ArrayServidores: [],
      ArrayRutas: [],
      ArrayTipoContenido: [],
      ArrayFormatos: [],
      ArrayPlantillas: [],
      ArrayServicios: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",

        email: (v) =>
          !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Correo electrónico inválido",
      },
    };
  },

  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Consultas a Ejecutar
      var userperfil = this.$store.getters.userperfil;
      this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
      this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

      if (this.editedIndex != -1) {
        this.putRegistro();
      } else {
        this.postRegistro();
      }
    },

    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      try {
        const result = await postInsert(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      try {
        const result = await putUpdate(this.editedItem);
        this.reset();
        var data = false;
        this.$emit("update:page", data);
        this.$emit("update:Exito", result);
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },

    // Cambio Tipo Contenido
    ChangeTipoContenido() {
      this.editedItem.RutaServidorIDCombinacion = null;
      this.editedItem.RutaIDCombinacion = null;
      this.editedItem.RutaPlantillaServidorID = null;
      this.editedItem.RutaPlantillaID = null;
      this.editedItem.NombrePlantilla = null;
      this.editedItem.FormatoPlantilla = null;
      this.editedItem.FilaColumnaPlantilla = null;
      this.editedItem.PlantillaID = null;
    },

    // Cambio Vigencia
    ChangeVigencia() {
      if (!this.editedItem.ChequeaVigencias) {
        this.editedItem.DiasVigencia = null;
      }
    },

    // Cambio Servicios
    ChangeServicios() {
      if (!this.editedItem.VisibleServicios) {
        this.editedItem.ServicioID1 = null;
        this.editedItem.ServicioID2 = null;
        this.editedItem.ServicioID3 = null;
        this.editedItem.ServicioID4 = null;
        this.editedItem.ServicioID5 = null;
      }
    },

    // Cargue Combos
    CargueCombos() {
      var Tables = this.$store.getters.MTablaSeleccion;

      var rutas = this.$store.getters.MRuta;
      this.ArrayRutas = rutas;

      var servidores = this.$store.getters.MServidor;
      this.ArrayServidores = servidores;

      var formatos = this.$store.getters.MConversion;
      this.ArrayFormatos = formatos;

      var services = this.$store.getters.MServicio;
      this.ArrayServicios = services;

      var plantillas = this.$store.getters.MPlantilla;
      this.ArrayPlantillas = plantillas;

      this.ArrayIndicativoCarpeta = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.IndicativoCarpeta
      );

      this.ArrayTipoContenido = Tables.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.TipoContenido
      );
    },

    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
